import React from 'react';
import { Calendar } from 'primereact/calendar';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';
import CalendarHeader from '../CalendarHeader/CalendarHeader';
import CalendarFooter from '../CalendarFooter/CalendarFooter';
import { useSelector } from 'react-redux';
import { isToday } from 'src/utils/dateUtils';

const MonthView = ({ changeSelectedDate }) => {
    const selectedDate = useSelector(
        (state) => state.filterReducer.selectedDate
    );

    return (
        <Calendar
            value={selectedDate}
            onChange={(e) => {
                changeSelectedDate(e.value);
            }}
            viewDate={selectedDate}
            onViewDateChange={(e) => {
                changeSelectedDate(e.value);
            }}
            headerTemplate={() => (
                <CalendarHeader
                    showTodayButton={!isToday(selectedDate)}
                    changeSelectedDate={changeSelectedDate}
                />
            )}
            footerTemplate={() => <CalendarFooter />}
            inline
        />
    );
};

export default MonthView;
